<template>
  <div class="nav-bar">
    <div class="nav-bar-line"></div>

    <b-navbar toggleable="lg" class="nav-bar-home">
      <b-navbar-brand to="/">
        <b-img :src="brandLogo" fluid alt="Brand Logo" class="brand-logo">
        </b-img
      ></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/about-me">About Me</b-nav-item>
          <b-nav-item to="/projects">Projects</b-nav-item>
          <b-nav-item to="/contact">Contact</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="nav-bar-line"></div>
  </div>
</template>

<script>
import logo from "../assets/logo.png";
export default {
  name: "Navbar",
  data() {
    return {
      brandLogo: logo,
    };
  },
};
</script>

<style>
.nav-bar-home {
  background: transparent !important;
}

.nav-bar-home img {
  width: 5vw !important;
}

.nav-bar-home * {
  margin-left: 5px;
}
.nav-bar-home button {
  background: #ffa600 !important;
}
.nav-bar-home a {
  color: #a8a9ad !important;
  font-weight: bold !important;
  font-size: 2vw !important;
  text-shadow: 2px 2px #000000;

  transition: 0.3s color;
}

.nav-bar-home a:hover {
  color: #ffa600 !important;
}
.nav-bar-line {
  background-color: #ffa600;
  border: 0.1vw solid #ffa600;
  border-radius: 50px;
}

.nav-bar-home{
  text-align: center !important;
}

/*****************************************************/
@media only screen and (max-width: 1032px) {
  .nav-bar-home img {
    width: 10vw !important;
  }

  .nav-bar-home a {
    font-size: 3.5vw !important;
  }
  .nav-bar-line {
    height: 2px;
    background-color: #ffa600;
    border: 0.1vw solid #ffa600;
    border-radius: 50px;
  }
}

/* Small phones to small tablets: from 481 to 767*/
@media only screen and (max-width: 767px) {
  .nav-bar-home {
    text-align: center;
  }
  .nav-bar-home img {
    width: 15vw !important;
    margin: auto;
  }

  .nav-bar-home * {
    margin-left: 5px;
  }

  .nav-bar-home a {
    font-size: 5vw !important;
  }

  .nav-bar-home a:hover {
    color: #ffa600 !important;
  }
  .nav-bar-line {
    height: 2px;
    background-color: #ffa600;
    border: 0.1vw solid #ffa600;
    border-radius: 50px;
  }
}

/*Small Phone from 0 to 480px*/
@media only screen and (max-width: 400px) {
  .nav-bar-home {
    text-align: center;
  }
  .nav-bar-home img {
    width: 15vw !important;
    margin: auto;
  }

  .nav-bar-home * {
    margin-left: 5px;
  }

  .nav-bar-home a {
    font-size: 5vw !important;
  }

  .nav-bar-home a:hover {
    color: #ffa600 !important;
  }
  .nav-bar-line {
    height: 2px;
    background-color: #ffa600;
    border: 0.1vw solid #ffa600;
    border-radius: 50px;
  }
}
</style>
